import { Badge } from '@interstate/components/Badge';
import { RadioButtonList } from '@interstate/components/RadioButtonList';

import { DeskingCardSelectDraftDeal } from './DeskingCard.style';
import { dealLockHooks } from '@makemydeal/dr-dash-components';

export interface DeskingCardDealLabelProps {
    isPrimaryScope: boolean;
    scopeId: string;
    onChangePrimaryDeal: () => void;
}

export const DeskingCardDealLabel = ({ isPrimaryScope, scopeId, onChangePrimaryDeal }: DeskingCardDealLabelProps) => {
    const isLocked = dealLockHooks.useIsDealLocked();
    return isPrimaryScope ? (
        <Badge variant="info" data-testid="primary-deal-label">
            <span>Primary</span>
        </Badge>
    ) : (
        <DeskingCardSelectDraftDeal>
            <RadioButtonList
                inline
                displayLabel={false}
                data-testid="draft-deal-select"
                options={[{ label: 'Select', value: scopeId, disabled: isLocked }]}
                onChange={onChangePrimaryDeal}
            ></RadioButtonList>
        </DeskingCardSelectDraftDeal>
    );
};
